import {Injectable} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import * as _ from 'lodash';
import {Subscription} from 'rxjs';
import {UpdateDynamicFormService} from './update-dynamic-form.service';
import {EnableDisableFormgroupService} from './enable-disable-formgroup.service';

@Injectable({
  providedIn: 'root'
})
export class WifiFormLogicService {
  private sub$: Subscription;
  private subscriptions = [];
  private isVideo;

  constructor(private updateDynamicFormService: UpdateDynamicFormService, private enableDisableFormGroup: EnableDisableFormgroupService) {

  }

  videoStatus(value: any): void {  // tslint:disable-line
    this.isVideo = value;
  }

  /**
   * cette fonction permet si le wifi est enable d'ajouter un validateur au ssid
   * et si la sécurité est nulle d'initialise la sécurité à WPA2
   * et si le wi-fi est disabeld d'enlever le validateur du ssid et nettoie le formulaire
   * @param form FormGroup
   *
   */

  validatorWifi(form: any): void {  // tslint:disable-line
    this.sub$ = form.get(['wifi', 'enable']).valueChanges.pipe(distinctUntilChanged((x, y) => _.isEqual(x, y)), debounceTime(100)).subscribe(enable => {
      if (this.isVideo && form.get(['wifi', 'enable']).enabled) {
        if (enable) {
          form.get(['wifi', 'ssid']).setValidators([Validators.required]);
          form.get(['wifi', 'ssid']).updateValueAndValidity();
          if (!form.get(['wifi', 'security_type']).value.code) {
            form.get(['wifi', 'security_type', 'code']).patchValue('WPA2');
          }
        } else {
          form.get(['wifi', 'ssid']).clearValidators();
          form.get(['wifi', 'ssid']).updateValueAndValidity();
          form.get(['wifi']).reset();
          form.get(['wifi']).markAsDirty();
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  /**
   * cette fonction ecoute le type de sécurité
   * ajoute ou nettoie  le validateur sur password en fonction du type de sécurité.
   * et addapte le formulaire en fonction du type de sécurité.
   * @param form FormGroup
   *
   */
  validatorWifiSecurity(form: any): void {  // tslint:disable-line
    this.sub$ = form.get(['wifi', 'security_type']).valueChanges.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(type => {
      if (this.isVideo && form.get(['wifi']).enabled) {
        const initArrayWifiForm = [
          'security_password',
          'eap_methodName',
          'eap_phase_2_authentication',
          'eap_ca_certificate',
          'eap_user_certificate',
          'eap_identity',
          'eap_anonymous_identity',
          'eap_password'];
        if (type.code === 'WEP' || type.code === 'WPA2' || type.code === 'WPA2AES') {
          form.get(['wifi', 'security_password']).setValidators([Validators.required]);
          this.restWifiPartialForm(form, initArrayWifiForm);
        } else {
          form.get(['wifi', 'security_password']).clearValidators();
          this.restWifiPartialForm(form, initArrayWifiForm);
        }
        if (type.code === '802' && !form.get(['wifi', 'eap_methodName']).value.code) {
          form.get(['wifi', 'eap_methodName', 'code']).patchValue('PWD');

        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  /**
   * cette fonction ecoute le EAP method.
   * ajoute ou nettoie  le validateur sur password et identity en fonction de la EAP method.
   * et addapte le formulaire en fonction de la EAP method.
   * @param form FormGroup
   *
   */
  validatorWifiEap(form: any): void {  // tslint:disable-line
    this.sub$ = form.get(['wifi', 'eap_methodName']).valueChanges.pipe(
      distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(methodName => {
      if (this.isVideo && form.get(['wifi']).enabled) {
        const arrayWifiForm = [
          'security_password',
          'eap_phase_2_authentication',
          'eap_ca_certificate',
          'eap_user_certificate',
          'eap_identity',
          'eap_anonymous_identity',
          'eap_password'];
        if (methodName.code !== 'TLS' && form.get(['wifi', 'security_type']).value.code === '802') {
          form.get(['wifi', 'eap_password']).setValidators([Validators.required]);
          form.get(['wifi', 'eap_identity']).setValidators([Validators.required]);
          this.restWifiPartialForm(form, arrayWifiForm);
        } else {
          form.get(['wifi', 'eap_password']).clearValidators();
          form.get(['wifi', 'eap_identity']).clearValidators();
          this.restWifiPartialForm(form, arrayWifiForm);

        }
        if (methodName.code !== 'PEAP' ||
          methodName.code !== 'TTLS' &&
          !form.get(['wifi', 'eap_phase_2_authentication']).value.code) {
          form.get(['wifi', 'eap_phase_2_authentication', 'code']).patchValue('NONE');
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  /**
   * cette fonction permet de reset le formulaire sur les champs reçus en paramètre.
   * @param form FormGroup
   * @param arrayWifiForm  string array
   *
   */
  restWifiPartialForm(form: FormGroup, arrayWifiForm: string[]): void {
    if (form.get(['wifi']).enabled) {
      for (let i = 0; i < arrayWifiForm.length; i++) {
        form.get(['wifi', arrayWifiForm[i]]).reset();
      }
    }
  }

  /**
   * cette fonction permet d'afficher/cacher les inputs en fonction des données du formulaire.
   * @param form FormGroup
   * @param isLoadingWifi  string array
   *
   */
  wifiToggleElemInit(form: any, isLoadingWifi: boolean): void {  // tslint:disable-line
    this.sub$ = form.get(['wifi']).valueChanges.pipe(
    ).subscribe(value => {
      if (!value.enable && !value.ssid) {
        this.initWifiForm();
      }
      if (value.enable) {
        this.initWifiForm();

        if (value && value.security_type) {
          if (value.security_type.code === 'WEP' || value.security_type.code === 'WPA2' || value.security_type.code === 'WPA2AES') {
            this.updateWifiForm(['security_password'], true);
          }
          if (value.security_type.code === '802') {
            this.updateWifiForm(['eap_methodName'], true);
          }
          if (value.security_type.code === '802' && value.eap_methodName.code === 'PEAP' || value.eap_methodName.code === 'TTLS') {
            const arrayWifiForm = [
              'eap_methodName', 'eap_phase_2_authentication', 'eap_ca_certificate',
              'eap_identity', 'eap_anonymous_identity', 'eap_password'];
            this.updateWifiForm(arrayWifiForm, true);
          }
          if (value.security_type.code === '802' && value.eap_methodName.code === 'TLS') {
            const arrayWifiForm = ['eap_methodName', 'eap_ca_certificate', 'eap_identity', 'eap_user_certificate'];
            this.updateWifiForm(arrayWifiForm, true);
          }
          if (value.security_type.code === '802' && value.eap_methodName.code === 'PWD') {
            const arrayWifiForm = ['eap_methodName', 'eap_identity', 'eap_password'];
            this.updateWifiForm(arrayWifiForm, true);
          }
        }
      }
      isLoadingWifi = false;
    });
    this.subscriptions.push(this.sub$);
  }

  initWifiForm(): void {
    const initArrayWifiForm = [
      'security_password',
      'eap_methodName',
      'eap_phase_2_authentication',
      'eap_ca_certificate',
      'eap_user_certificate',
      'eap_identity',
      'eap_anonymous_identity',
      'eap_password'];
    this.updateWifiForm(initArrayWifiForm, false);
  }

  /**
   * cette fonction affichage ou cacher un element du formulaire
   * @param arrayWifiForm array de string avec le nom du controller a update
   * @param status boolean pour affiche/cache
   *
   */
  updateWifiForm(arrayWifiForm: string[], status: boolean): void {
    for (let i = 0; i < arrayWifiForm.length; i++) {
      this.updateDynamicFormService.updateElement(arrayWifiForm[i], status, 'toggle');
    }
  }

  /**
   * cette fonction permet d'enlever tous les validateurs du formulaire Wi-Fi.
   * @param form FormGroup
   * @param isLoadingWifi  string array
   *
   */
  clearWifiValidator(form: any): void { // tslint:disable-line
    form.get(['wifi', 'ssid']).clearValidators();
    form.get(['wifi', 'ssid']).updateValueAndValidity();
    form.get(['wifi', 'security_password']).clearValidators();
    form.get(['wifi', 'security_password']).updateValueAndValidity();
    form.get(['wifi', 'eap_password']).clearValidators();
    form.get(['wifi', 'eap_password']).updateValueAndValidity();
    form.get(['wifi', 'eap_identity']).clearValidators();
    form.get(['wifi', 'eap_identity']).updateValueAndValidity();
  }

  get SubscriptionList(): Subscription[] {
    return this.subscriptions;
  }

  isWifiEnabledChange(form: FormGroup, path: string[]): void {
    this.sub$ = form.get(path.concat(['enable'])).valueChanges.subscribe(val => {
      if (form.get(path.concat(['enable'])).enabled) {
        if (val) {
          this.enableDisableFormGroup.enableFormElements(form, path, [
            'security_type', 'ssid', 'security_password', 'eap_methodName', 'eap_phase_2_authentication',
            'eap_ca_certificate', 'eap_user_certificate', 'eap_identity', 'eap_anonymous_identity', 'eap_password']);
        } else if (!val) {
          this.enableDisableFormGroup.disableFormElements(form, path, [
            'security_type', 'ssid', 'security_password', 'eap_methodName', 'eap_phase_2_authentication',
            'eap_ca_certificate', 'eap_user_certificate', 'eap_identity', 'eap_anonymous_identity', 'eap_password']);
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  // ngOnChanges
  isDhcpValueChange(form: FormGroup, path: string[]): void {
    this.sub$ = form.get(path.concat(['isDhcp'])).valueChanges.subscribe(val => {
      if (form.get(path.concat(['isDhcp'])).enabled) {
        if (val) {
          this.enableDisableFormGroup.disableFormElements(form, path,
            ['dns1', 'dns2', 'gateway', 'ip', 'mask']);
        } else if (!val) {
          this.enableDisableFormGroup.enableFormElements(form, path,
            ['dns1', 'dns2', 'gateway', 'ip', 'mask']);
        }
      }
    });
    this.subscriptions.push(this.sub$);
  }

  setMandatoryProxy(form: FormGroup, path: string[]): void { // TODO: move to parent order-detail
    this.sub$ = form.get(path).valueChanges.pipe(distinctUntilChanged((x, y) => _.isEqual(x, y))).subscribe(proxy => {
      if (proxy.port || proxy.addressProxy) {
        form.get(path.concat(['port']))
          .setValidators([Validators.required, Validators.min(1), Validators.max(65535), Validators.pattern('^[0-9]*$')]);
        form.get(path.concat(['port'])).updateValueAndValidity();
        form.get(path.concat(['addressProxy'])).setValidators([Validators.required]);
        form.get(path.concat(['addressProxy'])).updateValueAndValidity();
      } else {
        form.get(path.concat(['port'])).clearValidators();
        form.get(path.concat(['port'])).updateValueAndValidity();
        form.get(path.concat(['addressProxy'])).clearValidators();
        form.get(path.concat(['addressProxy'])).updateValueAndValidity();
      }
    });
    this.subscriptions.push(this.sub$);
  }
}
